<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="flex align-items-center gap-4">
                <div class="w-6rem h-6rem bg-gray-100 border-round flex align-items-center justify-content-center">
                    <i *ngIf="selectionTypeRequisition.cle === 1" class="pi pi-truck text-4xl"></i>
                    <i *ngIf="selectionTypeRequisition.cle === 2" class="pi pi-undo text-4xl"></i>
                    <i *ngIf="selectionTypeRequisition.cle === 3" class="pi pi-arrows-h text-4xl"></i>
                </div>
				<div class="flex flex-column justify-content-center gap-1">
					<div class="flex align-items-center gap-2">
						<h5 class="m-0">Transport: {{selectionTypeRequisition.valeur}}</h5>
						<span class="statut nouveau">
							Nouveau
						</span>
					</div>
					<span *ngIf="selectionTypeRequisition.cle === 1">En direction vers un chantier</span>
					<span *ngIf="selectionTypeRequisition.cle === 2">De retour d'un chantier</span>
					<span *ngIf="selectionTypeRequisition.cle === 3">Transfert entre deux chantiers</span>
				</div>
			</div>
		</p-card>

	</div>
</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2">
					<p-selectButton [options]="typesRequisition" [(ngModel)]="selectionTypeRequisition" optionLabel="valeur" (onChange)="surChangementTypeRequisition()"></p-selectButton>	
				</div>
				
			</div>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2">
					<label for="lastname">Date</label>
					<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateRequisition" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" ></p-calendar>
				</div>
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2">
					<label for="demandeur">Demandeur<span *ngIf="this.selectionTypeRequisition.cle == 1 || this.selectionTypeRequisition.cle == 3" class="requis">*</span></label>
					<p-dropdown #champDemandeur [options]="listeEmployes" [(ngModel)]="selectionDemandeur" optionLabel="nom"
						[showClear]="true" filter="true" filterBy="prenom,nom"
						appendTo="body" placeholder="Sélectionner un demandeur...">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionDemandeur">
								<div>{{selectionDemandeur.prenom}} {{selectionDemandeur.nom}}</div>
							</div>
						</ng-template>
						<ng-template let-employe pTemplate="item">
							<div>
								<div>{{employe.prenom}} {{employe.nom}}</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !selectionDemandeur">Le demandeur est obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-2 my-2">
					<label for="camion">Camion</label>
					<input id="camion" type="text" pInputText [(ngModel)]="camion">
				</div>
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-2 my-2">
					<label for="remorque">Remorque</label>
					<input id="remorque" type="text" pInputText [(ngModel)]="remorque">
				</div>
				<div class="flex flex-column gap-2 col-12 md:col-6 my-2">
					<label for="chauffeur">Chauffeur</label>
					<input id="chauffeur" type="text" pInputText [(ngModel)]="chauffeur">
				</div>
			</div>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 col-12 lg:col-6 my-2">
	
					<label for="lastname">Emplacement de départ<span class="requis">*</span></label>
					<p-dropdown [options]="emplacements" [(ngModel)]="selectionEmplacementSource" optionLabel="nom"
					[disabled]="this.selectionTypeRequisition.cle == 1"
						appendTo="body" [showClear]="true" filter="true" filterBy="code,nom"
						placeholder="Sélectionner un emplacement...">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionEmplacementSource">
								<div>{{selectionEmplacementSource.nom}} ({{selectionEmplacementSource.code}})</div>
							</div>
						</ng-template>
						<ng-template let-emplacement pTemplate="item">
							<div>
								<div>{{emplacement.nom}} ({{emplacement.code}})</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !selectionEmplacementSource">L'emplacement de départ
						est
						obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 col-12 lg:col-6 my-2">
	
					<label for="lastname">Emplacement de destination<span class="requis">*</span></label>
					<p-dropdown [options]="emplacements" [(ngModel)]="selectionEmplacementDestination" optionLabel="nom"
					[disabled]="this.selectionTypeRequisition.cle == 2"
						appendTo="body" [showClear]="true" filter="true" filterBy="code,nom"
						placeholder="Sélectionner un emplacement...">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionEmplacementDestination">
								<div>{{selectionEmplacementDestination.nom}} ({{selectionEmplacementDestination.code}})</div>
							</div>
						</ng-template>
						<ng-template let-emplacement pTemplate="item">
							<div>
								<div>{{emplacement.nom}} ({{emplacement.code}})</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !selectionEmplacementDestination">L'emplacement de destination
						est
						obligatoire.</small>
				</div>
			</div>
			<div class="col-12 text-right">
				<p-button label="Suivant" (click)="CreerRequisition()" icon="pi pi-save"
					iconPos="left"></p-button>
			</div>
		</p-card>
	</div>


</div>